module.exports = __webpack_public_path__ + "static/media/brand-refresh-Cookie.5bd38c75.svg";